import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import ListItemText from '@mui/material/ListItemText';
import { useRouter } from 'src/routes/hook';
import { useChatContext } from '../context/chat-context';
import { paths } from '../../../routes/paths';
import { useSiteContext } from '../../../components/site/context/site-context';

const CustomMessage = ({state, setState, scrollIntoView, actionProvider}) => {

  const router = useRouter();

  const {site} = useSiteContext();

  const [message, setMessage] = React.useState(null);

  const [status, setStatus] = React.useState(null);

  const [formatData, setFormatData] = React.useState(null);

  const {setAddMessageFunc, setMessageStatusFunc, setFormatMessageFunc} = useChatContext();

  const [listItems, setListItems] = React.useState(null);

  const uidKey = Math.random().toString(32).substring(2);

  // str add message to message string
  const addMessage = (str) =>
    setMessage((prev) => ({
      message: prev ? prev.message + str : str,
  }));

  const setLinkDataFunc = (data) => {
    setFormatData(data);
  }

  useEffect(() => {
    setAddMessageFunc(addMessage);
    setMessageStatusFunc(setStatus);
    setFormatMessageFunc(setLinkDataFunc);
  }, [setAddMessageFunc, setMessage, setState, setMessageStatusFunc, setStatus, setFormatMessageFunc]);

  if (message) {

    const getLinkText = (linkType) => {
      switch (linkType) {
        case "page_edit":
          return "ページ変更";
        case "page_config_edit":
          return "ページ設定変更";
        case "page_create":
          return "ページ作成";
        case "page_post_create":
          return "記事ページ作成";
        case "site_edit":
          return "サイト変更";
        case "site_config_edit":
          return "サイト設定項目変更";
        case "post_type_create":
          return "記事タイプ作成";
        case "post_type_edit":
          return "記事タイプ変更";
        case "post_type_config_edit":
          return "記事タイプ設定変更";
        case "post_create":
          return "記事作成";
        case "post_edit":
          return "記事変更";
        case "post_config_edit":
          return "記事設定変更";
        case "post_category_create":
          return "記事カテゴリ作成";
        case "post_category_edit":
          return "記事カテゴリ変更";
        case "post_category_config_edit":
          return "記事カテゴリ設定変更";
        case "template_create":
          return "テンプレート作成";
        case "layout_create":
          return "レイアウト作成";
        case "block_create":
          return "ブロック作成";
        case "qa_task_list":
          return "QA生成タスク一覧";
        case "qa_list":
          return "QAリスト";
        case "qa_detail":
          return "QA詳細";
        case "qa_task_detail":
          return "QAタスク詳細";
        default:
          return "-";
      }
    };

    return <ListItemText key={uidKey}>
      <div style={{
        backgroundColor: '#f0f0f0',
        color: '#333',
        padding: '12px 15px',
        borderRadius: '15px 15px 15px 0',
        margin: '8px 0',
        maxWidth: '85%',
        alignSelf: 'flex-start',
        fontSize: '15px',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        lineHeight: '1.4',
      }}>
        {(message.message || '')
          .split('\n')
          .map((line, index, arr) => (
            <React.Fragment key={index}>
              {line}
              {index < arr.length - 1 && <br />}
            </React.Fragment>
          ))}
      </div>
      {formatData && formatData.map((data, index) => {
        if (data.type === 'link') {
          let add_message = ""
          if (data?.page_name) {
            add_message = `:${data.page_name}`;
          }
          return (
            <ListItemText key={`${uidKey}_${index}`}>
              <Link onClick={
                () => {
                  switch (data.link_type) {
                    case "page_edit":
                      router.push(paths.dashboard.page.edit(site.code, data.page_id));
                      break
                    case "page_config_edit":
                      router.push(paths.dashboard.config.page_layout_list(site.code, data.page_pkg_code, data.page_id));
                      break
                    case "page_create":
                      router.push(paths.dashboard.config.page_add(site.code));
                      break
                    case "page_post_create":
                      router.push(paths.dashboard.config.page_post_add(site.code));
                      break
                    case "site_edit":
                      router.push(paths.dashboard.site.edit(site.code));
                      break
                    case "site_config_edit":
                      router.push(paths.dashboard.config.site_layout_list(site.code));
                      break
                    case "post_type_create":
                      router.push(paths.dashboard.config.post_type_add(site.code));
                      break
                    case "post_type_edit":
                      router.push(paths.dashboard.post_type.edit(site.code, data.post_type_id));
                      break
                    case "post_type_config_edit":
                      router.push(paths.dashboard.config.post_type_layout_list(site.code, data.post_type_id));
                      break
                    case "post_create":
                      router.push(paths.dashboard.posts.new(site.code, data.post_type_id));
                      break
                    case "post_edit":
                      router.push(paths.dashboard.posts.edit(site.code, data.post_type_id, data.post_id));
                      break
                    case "post_config_edit":
                      router.push(paths.dashboard.config.post_layout_list(site.code, data.post_type_id));
                      break
                    case "post_category_create":
                      router.push(paths.dashboard.posts.category_new(site.code, data.post_type_id));
                      break
                    case "post_category_edit":
                      router.push(paths.dashboard.posts.category_edit(site.code, data.post_type_id, data.category_id));
                      break
                    case "post_category_config_edit":
                      router.push(paths.dashboard.config.post_category_layout_list(site.code, data.post_type_id));
                      break
                    case "template_create":
                      router.push(paths.dashboard.template.new(site.code));
                      break
                    case "layout_create":
                      router.push(paths.dashboard.template.layout_new(site.code));
                      break
                    case "block_create":
                      router.push(paths.dashboard.template.block_new(site.code));
                      break
                    case "qa_task_list":
                      router.push(paths.dashboard.qa_generation_task.root(site.code));
                      break
                    case "qa_list":
                      router.push(paths.dashboard.qa_generation_task.details(site.code, data.task_id));
                      break
                    case "qa_detail":
                      router.push(paths.dashboard.qa_generation_task.details(site.code, data.task_id));
                      break
                    case "qa_task_detail":
                      router.push(paths.dashboard.qa_generation_task.details(site.code, data.task_id));
                      break
                    default:
                      break
                  }
                }
              }>
                {getLinkText(data.link_type)}{add_message}
              </Link>
            </ListItemText>
          );
        }
        return null;
      })}
    </ListItemText>;
  }

  return null;
};

export default CustomMessage;

CustomMessage.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func,
  scrollIntoView: PropTypes.func,
  actionProvider: PropTypes.func,
}
